import { useEffect, useState } from 'react'
import { Button, Typography } from '@mui/material'
import { useProject } from '../context/project'
import Modal from '../components/Modal'
import Spinner from './Spinner'
import CompanyLogo from './CompanyLogo'
import visualizationStyles from '../pages/visualization/components/Visualization.module.scss'
import { useGeneral } from '../context/general'

export default function ProjectRestoationModal({projectId, tickerInfo, ticker}) {
    const { clearProject, isEmpty } = useProject()
    const { projectMethods } = useGeneral()
    const { added } = projectMethods.getWatchlistStatus(projectId)
    const [ modalFlag, setModalFlag ] = useState(false)
    const [ open, setOpen ] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(()=> {
        if(isEmpty !== null && added !== null){
            !modalFlag && !added && !isEmpty && setOpen(true)
            setModalFlag(true) 
        } 
        return () => {}
    },[added, modalFlag, isEmpty])

    useEffect(()=>{
        (isEmpty || added) && setOpen(false)
        return () => {}
    },[added, isEmpty])

    const handleDiscard = async () => {
        setLoading(true)
        await clearProject()
    }

    const handleSave = () => setOpen(false)
    
    const buttons = [
        <Button key='no' variant="outlined" onClick={handleDiscard} disabled={loading}>No</Button>,
        <Button style={{backgroundColor:'#dccb03',color:'black'}} key= 'yes' variant="contained" color="active" onClick={handleSave} disabled={loading}>Yes</Button>
    ]

    return (<Modal open={open} buttons={buttons}>
            <div className={visualizationStyles['restoation-modal']}>
                {loading
                    ? <Spinner/> 
                    : <>
                        <div>
                            <CompanyLogo image={tickerInfo?.image} ticker={ticker} size={32}/>
                            <Typography variant="h2">{tickerInfo?.companyName}</Typography>
                        </div>
                        <div>Do you wish to continue from where you left off?</div>
                    </>}
            </div>
            </Modal>
            )
}